module.exports = __webpack_public_path__ + "static/media/activity-selected.3a0ebdbc.svg";